import { IEnvironment } from './environment.model';

export const environmentBase: IEnvironment = {
  name: 'development',
  apiUrl: '',
  maxGroupsSize: 20,
  maxUsersSize: 50,
};
